import modeles00x00 from "./modeles00x00.js";
import modeles03x03 from "./modeles03x03.js";
import modeles03x05 from "./modeles03x05.js";
import modeles03x17 from "./modeles03x17.js";
import modeles03x33 from "./modeles03x33.js";
import modeles04x04 from "./modeles04x04.js";
import modeles04x05 from "./modeles04x05.js";
import modeles05x05 from "./modeles05x05.js";
import modeles05x06 from "./modeles05x06.js";
import modeles05x09 from "./modeles05x09.js";
import modeles05x17 from "./modeles05x17.js";
import modeles05x22 from "./modeles05x22.js";
import modeles06x05 from "./modeles06x05.js";
import modeles06x06 from "./modeles06x06.js";
import modeles06x16 from "./modeles06x16.js";
import modeles07x07 from "./modeles07x07.js";
import modeles07x10 from "./modeles07x10.js";
import modeles07x11 from "./modeles07x11.js";
import modeles07x31 from "./modeles07x31.js";
import modeles08x06 from "./modeles08x06.js";
import modeles08x07 from "./modeles08x07.js";
import modeles08x08 from "./modeles08x08.js";
import modeles08x09 from "./modeles08x09.js";
import modeles08x11 from "./modeles08x11.js";
import modeles08x29 from "./modeles08x29.js";
import modeles08x30 from "./modeles08x30.js";
import modeles08x31 from "./modeles08x31.js";
import modeles09x08 from "./modeles09x08.js";
import modeles09x09 from "./modeles09x09.js";
import modeles09x11 from "./modeles09x11.js";
import modeles09x12 from "./modeles09x12.js";
import modeles09x15 from "./modeles09x15.js";
import modeles09x16 from "./modeles09x16.js";
import modeles10x08 from "./modeles10x08.js";
import modeles10x09 from "./modeles10x09.js";
import modeles10x10 from "./modeles10x10.js";
import modeles10x11 from "./modeles10x11.js";
import modeles10x14 from "./modeles10x14.js";
import modeles10x30 from "./modeles10x30.js";
import modeles10x32 from "./modeles10x32.js";
import modeles10x34 from "./modeles10x34.js";
import modeles11x10 from "./modeles11x10.js";
import modeles11x11 from "./modeles11x11.js";
import modeles11x12 from "./modeles11x12.js";
import modeles11x15 from "./modeles11x15.js";
import modeles11x22 from "./modeles11x22.js";
import modeles11x30 from "./modeles11x30.js";
import modeles11x39 from "./modeles11x39.js";
import modeles12x11 from "./modeles12x11.js";
import modeles12x12 from "./modeles12x12.js";
import modeles12x22 from "./modeles12x22.js";
import modeles12x23 from "./modeles12x23.js";
import modeles12x31 from "./modeles12x31.js";
import modeles13x13 from "./modeles13x13.js";
import modeles13x15 from "./modeles13x15.js";
import modeles13x23 from "./modeles13x23.js";
import modeles14x12 from "./modeles14x12.js";
import modeles14x13 from "./modeles14x13.js";
import modeles14x14 from "./modeles14x14.js";
import modeles14x19 from "./modeles14x19.js";
import modeles15x11 from "./modeles15x11.js";
import modeles15x14 from "./modeles15x14.js";
import modeles15x15 from "./modeles15x15.js";
import modeles15x16 from "./modeles15x16.js";
import modeles15x17 from "./modeles15x17.js";
import modeles15x19 from "./modeles15x19.js";
import modeles16x11 from "./modeles16x11.js";
import modeles16x15 from "./modeles16x15.js";
import modeles16x16 from "./modeles16x16.js";
import modeles16x23 from "./modeles16x23.js";
import modeles17x15 from "./modeles17x15.js";
import modeles17x17 from "./modeles17x17.js";
import modeles17x18 from "./modeles17x18.js";
import modeles17x20 from "./modeles17x20.js";
import modeles18x15 from "./modeles18x15.js";
import modeles18x17 from "./modeles18x17.js";
import modeles18x18 from "./modeles18x18.js";
import modeles18x21 from "./modeles18x21.js";
import modeles18x22 from "./modeles18x22.js";
import modeles19x14 from "./modeles19x14.js";
import modeles19x17 from "./modeles19x17.js";
import modeles19x19 from "./modeles19x19.js";
import modeles19x26 from "./modeles19x26.js";
import modeles20x17 from "./modeles20x17.js";
import modeles20x20 from "./modeles20x20.js";
import modeles20x37 from "./modeles20x37.js";
import modeles21x20 from "./modeles21x20.js";
import modeles21x21 from "./modeles21x21.js";
import modeles23x13 from "./modeles23x13.js";
import modeles23x21 from "./modeles23x21.js";
import modeles23x23 from "./modeles23x23.js";
import modeles24x24 from "./modeles24x24.js";
import modeles25x25 from "./modeles25x25.js";
import modeles26x17 from "./modeles26x17.js";
import modeles26x26 from "./modeles26x26.js";
import modeles27x19 from "./modeles27x19.js";
import modeles27x20 from "./modeles27x20.js";
import modeles27x21 from "./modeles27x21.js";
import modeles30x30 from "./modeles30x30.js";
import modeles31x31 from "./modeles31x31.js";
import modeles61x61 from "./modeles61x61.js";
        
        export default [
            ...modeles00x00,
...modeles03x03,
...modeles03x05,
...modeles03x17,
...modeles03x33,
...modeles04x04,
...modeles04x05,
...modeles05x05,
...modeles05x06,
...modeles05x09,
...modeles05x17,
...modeles05x22,
...modeles06x05,
...modeles06x06,
...modeles06x16,
...modeles07x07,
...modeles07x10,
...modeles07x11,
...modeles07x31,
...modeles08x06,
...modeles08x07,
...modeles08x08,
...modeles08x09,
...modeles08x11,
...modeles08x29,
...modeles08x30,
...modeles08x31,
...modeles09x08,
...modeles09x09,
...modeles09x11,
...modeles09x12,
...modeles09x15,
...modeles09x16,
...modeles10x08,
...modeles10x09,
...modeles10x10,
...modeles10x11,
...modeles10x14,
...modeles10x30,
...modeles10x32,
...modeles10x34,
...modeles11x10,
...modeles11x11,
...modeles11x12,
...modeles11x15,
...modeles11x22,
...modeles11x30,
...modeles11x39,
...modeles12x11,
...modeles12x12,
...modeles12x22,
...modeles12x23,
...modeles12x31,
...modeles13x13,
...modeles13x15,
...modeles13x23,
...modeles14x12,
...modeles14x13,
...modeles14x14,
...modeles14x19,
...modeles15x11,
...modeles15x14,
...modeles15x15,
...modeles15x16,
...modeles15x17,
...modeles15x19,
...modeles16x11,
...modeles16x15,
...modeles16x16,
...modeles16x23,
...modeles17x15,
...modeles17x17,
...modeles17x18,
...modeles17x20,
...modeles18x15,
...modeles18x17,
...modeles18x18,
...modeles18x21,
...modeles18x22,
...modeles19x14,
...modeles19x17,
...modeles19x19,
...modeles19x26,
...modeles20x17,
...modeles20x20,
...modeles20x37,
...modeles21x20,
...modeles21x21,
...modeles23x13,
...modeles23x21,
...modeles23x23,
...modeles24x24,
...modeles25x25,
...modeles26x17,
...modeles26x26,
...modeles27x19,
...modeles27x20,
...modeles27x21,
...modeles30x30,
...modeles31x31,
...modeles61x61,
        ].sort((m1, m2) => m1.date - m2.date);